<template>
    <div>
        <CRow>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>جزییات آمار ارسال</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CDataTable
                            hover
                            striped
                            columnFilter
                            :items="items"
                            :fields="fields"
                            :items-per-page="15"
                            :active-page="active_page"
                            :pagination="{ doubleArrows: true, align: 'center'}"
                            :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }"
                        >
                            <template #state="data">
                                <td>
                                    <CBadge :color="get_badge(data.item.state)">
                                        {{data.item.state}}
                                    </CBadge>
                                </td>
                            </template>
                            <template #delivery_base="data">
                                <td v-if="data.item.delivery_base"><CIcon name="cilCheckAlt" size="lg"/></td>
                                <td v-else><CIcon name="cilX" size="lg"/></td>
                            </template>
                        </CDataTable>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>
<script>
export default {
    data () {
        return {
            items: [],
            fields: [
                { key: 'created_at', label: 'تاریخ / زمان' },
                { key: 'count', label: 'تعداد پیام‌ها' },
                { key: 'page_count', label: 'تعداد صفحه‌ها' },
                { key: 'sms_fee', label: 'هزینه پیام‌ها' },
                { key: 'from_number', label: 'از شماره' },
                { key: 'operator_name', label: 'اپراتور' },
                { key: 'sms_gateway_id', label: 'درگاه' },
                { key: 'state', label: 'وضعیت' },
                { key: 'delivery_base', label: 'delivery base' },
            ],
            active_page: 1,
        }
    },
    mounted(){
        this.get();
    },
    methods: {
        get() {
            let user, from, to, state;
            this.$route.params.user == 0 ? user = '' : user = this.$route.params.user;
            this.$route.params.from == 0 ? from = '' : from = this.$route.params.from;
            this.$route.params.to == 0 ? to = '' : to = this.$route.params.to;
            this.$route.params.state == 0 ? state = '' : state = this.$route.params.state;
            this.axios.get('user_statistics/' 
                + '?id=' + this.$route.params.id
                + '&user_id=' + user
                + '&from_statistics_date=' + from
                + '&to_statistics_date=' + to
                + '&is_final=' + state
                + '&user_info=1')
                .then(res => {
                    res.data[0].items = [];
                    for(const key in res.data[0].user_statistics.statistics_detail){
                        for(const ke in res.data[0].user_statistics.statistics_detail[key]){
                            const items = {};
                            for(const k in res.data[0].user_statistics.statistics_detail[key][ke]){
                                for(const r in res.data[0].user_statistics.statistics_detail[key][ke][k]){
                                    if(r == 'created_at'){
                                        items[r] = this.$moment(res.data[0].user_statistics.statistics_detail[key][ke][k][r], 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                                    }
                                    else if(r == 'state'){
                                        switch(res.data[0].user_statistics.statistics_detail[key][ke][k][r]){
                                            case 1:
                                                items[r] = 'تحویل داده شده';
                                                break;
                                            case 2:
                                                items[r] = 'تحویل داده نشده';
                                                break;
                                            case 3:
                                                items[r] = 'ارسال شده به مخابرات';
                                                break;
                                            case 0:
                                                items[r] = 'در صف ارسال | ارسال شده و در انتظار تعیین وضعیت';
                                                break;
                                            case -1:
                                                items[r] = 'لیست سیاه';
                                                break;
                                            case -2:
                                                items[r] = 'تایید نشده';
                                                break;
                                            case -3:
                                                items[r] = 'خطا در ارسال';
                                                break;
                                        }
                                    }
                                    else{
                                        items[r] = res.data[0].user_statistics.statistics_detail[key][ke][k][r];
                                    }
                                }
                            }
                            res.data[0].items.push(items);
                        }
                    }
                    this.items = res.data[0].items;
                })
        },
        get_badge(status) {
            switch(status) {
                case 'لیست سیاه': return 'danger';
                case 'رد شده': return 'danger';
                case 'در صف ارسال | ارسال شده و در انتظار تعیین وضعیت': return 'info';
                case 'تحویل داده نشده': return 'danger';
                case 'تحویل داده شده': return 'success';
                case 'تایید نشده': return 'warning';
                case 'خطا در ارسال': return 'danger';
                case 'ارسال شده به مخابرات': return 'info';
            }
        },
    },
    beforeCreate() {
        if (this.$store.state.perms.view_user_info_statistics == false
            && this.$store.state.perms.view_all_users_statistics == false
            && this.$store.state.perms.view_same_group_users_statistics == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
